'use client';

import { X } from 'lucide-react';
import Link from 'next/link';
import { useTranslations } from 'next-intl';
import { Button } from '@/components/ui/button';
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarHeader,
  SidebarMenu,
  useSidebar,
  SidebarMenuItem,
  SidebarMenuButton,
} from '@/components/ui/sidebar';
import type { MenuPublicItemType } from './MenuPublicConfig';
import styles from './MobileMenu.module.css';

export default function MobileMenuPublic({
  menuItems,
  menuItemsAuth,
}: {
  menuItems: MenuPublicItemType[];
  menuItemsAuth: MenuPublicItemType[];
}) {
  const { setOpenMobile } = useSidebar();
  const t = useTranslations('menu');

  return (
    <Sidebar side='right'>
      <SidebarHeader className='items-end pb-1'>
        <Button
          variant='ghost'
          size='icon'
          className='hover:bg-transparent md:hidden'
          onClick={() => setOpenMobile(false)}
        >
          <X className='h-6 w-6' />
        </Button>
      </SidebarHeader>
      <SidebarContent className='overflow-hidden'>
        <div className='flex flex-1 transition-transform duration-300 ease-in-out'>
          <div className='flex w-full shrink-0 flex-col px-6'>
            <SidebarGroup className='flex-1'>
              <SidebarMenu className={styles.menuContainer}>
                <div className={styles.menuItems}>
                  {menuItems.map((item) => (
                    <SidebarMenuItem key={item.title}>
                      <SidebarMenuButton
                        className='h-auto py-2'
                        onClick={() => {}}
                      >
                        <Link
                          href={item.link}
                          onClick={() => setOpenMobile(false)}
                          className='text-lg leading-4 font-medium'
                          target='_blank'
                        >
                          {t(`${item.title}.title`)}
                        </Link>
                      </SidebarMenuButton>
                    </SidebarMenuItem>
                  ))}
                </div>
                <div className='mt-auto py-8'>
                  <SidebarMenu className='border-t pt-8'>
                    {menuItemsAuth.map((item) => (
                      <SidebarMenuItem key={item.title}>
                        <SidebarMenuButton
                          className='h-auto py-2'
                          onClick={() => {}}
                        >
                          <Link
                            href={item.link}
                            onClick={() => setOpenMobile(false)}
                            className='bg-primary hover:bg-primary-500 flex h-12 w-full items-center justify-center rounded-full text-base leading-4 font-normal text-white'
                          >
                            {t(`${item.title}.title`)}
                          </Link>
                        </SidebarMenuButton>
                      </SidebarMenuItem>
                    ))}
                  </SidebarMenu>
                </div>
              </SidebarMenu>
            </SidebarGroup>
          </div>
        </div>
      </SidebarContent>
    </Sidebar>
  );
}
